import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "samplecomponent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "InputTextArea", -1)
const _hoisted_3 = { class: "samplecomponent__article" }
const _hoisted_4 = { class: "samplecomponent__reactive" }
const _hoisted_5 = { class: "samplecomponent__component" }
const _hoisted_6 = { class: "samplecomponent__resizable" }
const _hoisted_7 = { class: "samplecomponent__options" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text--xs" }, "Props", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputTextArea = _resolveComponent("InputTextArea")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputSelect = _resolveComponent("InputSelect")
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_InputTextArea, {
              modelValue: _ctx.props.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.props.value = $event)),
              name: _ctx.props.name,
              label: _ctx.props.label,
              placeholder: _ctx.props.placeholder,
              size: _ctx.props.size,
              rows: parseInt(_ctx.props.rows),
              block: _ctx.props.block,
              disabled: _ctx.props.disabled,
              error: _ctx.props.error,
              labelHidden: _ctx.props.labelHidden
            }, null, 8, ["modelValue", "name", "label", "placeholder", "size", "rows", "block", "disabled", "error", "labelHidden"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.props.value = $event)),
              label: "value"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.props.name = $event)),
              label: "name"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.label,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.props.label = $event)),
              label: "label"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.placeholder,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.props.placeholder = $event)),
              label: "placeholder"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.rows,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.props.rows = $event)),
              label: "rows"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.props.size,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.props.size = $event)),
              options: _ctx.sizes,
              label: "size"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.block,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.props.block = $event)),
              label: "block"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.disabled,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.props.disabled = $event)),
              label: "disabled"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.error,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.props.error = $event)),
              label: "error"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.labelHidden,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.props.labelHidden = $event)),
              label: "labelHidden"
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}